import { TemplateMessage } from '../../api/types/scenario';
import styles from './SortableTemplateMessage.module.css';

interface SortableTemplateMessageProps {
  message: TemplateMessage;
  index: number;
  moveMessage: (dragIndex: number, hoverIndex: number) => void;
}

function SortableTemplateMessage({ message }: SortableTemplateMessageProps): JSX.Element {
  const isCharacter = message.template_type === 'character';
  const currentCharacter = message.character;
  
  // Render the appropriate pill for the message type
  const renderTemplatePill = () => {
    switch(message.template_type) {
      case 'narrator':
        return (
          <span className={`${styles.templatePill} ${styles.narratorPill}`}>
            Narrator
          </span>
        );
      case 'user-slot':
        return (
          <span className={`${styles.templatePill} ${styles.userSlotPill}`}>
            {'{{USER}}'}
          </span>
        );
      case 'char-slot':
        return (
          <span className={`${styles.templatePill} ${styles.charSlotPill}`}>
            {'{{CHAR}}'}
          </span>
        );
      case 'character':
        return null;
      default:
        return (
          <span className={styles.templatePill}>
            {message.template_type}
          </span>
        );
    }
  };
  
  return (
    <div className={styles.sortableMessage}>
      <div className={styles.dragHandle}>
        <div className={styles.dragIcon}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      
      <div className={styles.messageContent}>
        <div className={styles.messageHeader}>
          {renderTemplatePill()}
          
          {isCharacter && currentCharacter && (
            <>
              <div className={styles.avatarContainer}>
                <img 
                  src={currentCharacter.icon}
                  alt={currentCharacter.display_name}
                  className={styles.avatar}
                />
              </div>
              <span className={styles.characterName}>
                {currentCharacter.display_name}
              </span>
            </>
          )}
        </div>
        
        <div className={styles.messageText}>
          {message.content}
        </div>
      </div>
    </div>
  );
}

export default SortableTemplateMessage; 